import { inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { WebStorage } from "./web-storage";
@Injectable({
  providedIn: "root",
})
export class ProductFamilyFavoritesService {
  private webStorage = inject(WebStorage);
  private includedIdsSubject = new BehaviorSubject<string[]>(
    this.webStorage.productFamilyIdsIncluded ?? [],
  );
  includedIds$ = this.includedIdsSubject.asObservable();
  getIdsIncluded() {
    return this.includedIds$;
  }
  setIdsIncluded(ids: string[]) {
    this.webStorage.productFamilyIdsIncluded = ids ?? [];
    this.includedIdsSubject.next(this.webStorage.productFamilyIdsIncluded);
  }
  remove(id: string) {
    if (id) {
      this.setIdsIncluded(
        this.webStorage.productFamilyIdsIncluded.filter(
          (includedId) => includedId !== id,
        ),
      );
    }
  }
  add(id: string) {
    if (id) {
      const includedIds = this.webStorage.productFamilyIdsIncluded;
      if (!includedIds.includes(id)) {
        this.setIdsIncluded([...includedIds, id]);
      }
    }
  }
}
